import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-footer',
  templateUrl: './home-page-footer.component.html',
  styleUrls: ['./home-page-footer.component.scss']
})
export class HomePageFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
